export default {
    namespaced: true,
    state: {
        onPhone: false,
        leadId: null
    },
    mutations: {
        SET_ON_PHONE(state, onPhone) {
            state.onPhone = onPhone;
        },
        SET_LEAD_ID(state, id) {
            state.leadId = id;
        }
    },
    getters: {
        onPhone: state => state.onPhone,
        leadId: state => state.leadId
    },
    actions: {
    },
}